export enum CategoryType {
  Geography = 1,
  AssetClass = 2,
  Portfolio = 8,
  Environment = 3,
  SecurityAccount = 4,
  Allocation = 5,
  Esg = 6,
  BankAccount = 7,
  Sector = 10,
  IndustryGroup = 11,
  Industry = 12,
  SubIndustry = 13,
  Sensitivity = 14,
  Custom1 = 20,
  Custom2 = 21,
  Custom3 = 22,
  Custom4 = 23,
  Custom5 = 24,
  Custom6 = 25,
  Custom7 = 26,
  Custom8 = 27,
  Custom9 = 28,
  MsSuperSector = 50,
  MsSector = 51,
  MsIndustryGroup = 52,
  MsIndustry = 53
}
